import React from "react";
import {
  getCurrentUser,
  fetchMFAPreference,
  setUpTOTP,
  verifyTOTPSetup,
  updateMFAPreference,
} from "aws-amplify/auth";
import QRCode from "qrcode.react";
import Form from "../common/form";
import packageJson from "../../../package.json";

export default class User extends Form {
  _isMounted = false;
  cognitoUser = undefined;
  mfa = "";
  issuer = "qr.vicuscapital.com";

  state = {
    mfaStatus: false,
    cognitoUserName: "",
    mfaString: "",
    mfaSetup: false,
    data: {
      mfaCode: "",
    },
  };

  componentDidMount = async () => {
    this._isMounted = true;
    this.cognitoUser = await getCurrentUser().catch((e) => {
      console.log("User not authenticated");
      return null;
    });
    this.mfa = await fetchMFAPreference();
    if (this.mfa !== "NOMFA") {
      if (this._isMounted) {
        this.setState({ mfaStatus: true });
      } else {
      }
    }
    if (this._isMounted) {
      this.setState({ cognitoUserName: this.cognitoUser.username });
    }
  };

  componentWillUnmount() {
    this._isMounted = false;
  }

  handleMFASignUp = async (event) => {
    event.preventDefault();
    if (!this.state.mfaStatus) {
      await setUpTOTP().then((code) => {
        this.setState({
          mfaString:
            "otpauth://totp/AWSCognito:" +
            this.cognitoUser.username +
            "?secret=" +
            code +
            "&issuer=" +
            this.issuer,
        });
      });
      this.setState({ mfaSetup: true });
    }
  };

  validateMFACodeLength() {
    const { data } = this.state;
    return data.mfaCode.length > 5;
  }

  handleMFAVerification = async (event) => {
    const { data } = this.state;
    event.preventDefault();
    await verifyTOTPSetup({ code: data.mfaCode });
    await updateMFAPreference({ totp: "PREFERRED" });
    this.setState({ mfaSetup: false });
    this.setState({ mfaStatus: true });
  };

  renderQR = () => {
    return (
      <div>
        <div>
          <QRCode value={this.state.mfaString} />
        </div>
        <div>
          {this.renderInput("mfaCode", "Multi-Factor Authentication Code")}
        </div>
        <div>
          <button
            style={{ margin: "10px 0" }}
            className="btn btn-primary"
            onClick={this.handleMFAVerification}
            disabled={!this.validateMFACodeLength()}
          >
            Complete Setup
          </button>
        </div>
      </div>
    );
  };

  render() {
    return (
      <div className="page-margin-top">
      <div className="container">
        <div className="row">
        <div className="col-lg-6 mx-auto card">
          <div className="card-body">
            <h5 className="card-title">User Info:</h5>
            <form onSubmit={this.handleMFASignUp}>
              <div>
                <label>Version: {packageJson.version}</label>
              </div>
              <div>
                <label>User: {this.state.cognitoUserName}</label>
              </div>
              <button
                type="submit"
                style={{ margin: "10px 0" }}
                className="btn btn-primary"
                disabled={this.state.mfaStatus ? true : false}
              >
                {this.state.mfaStatus
                  ? "Multi-Factor Authentication Setup Complete"
                  : "Setup Multi-Factor Authentication"}
              </button>
              {this.state.mfaSetup ? this.renderQR() : null}
              {this.state.mfaStatus ? (
                <React.Fragment>
                  <label>To disable MFA please contact support.</label>
                  <p>
                    Support:
                    <br />
                    (855) 558-4287
                  </p>
                </React.Fragment>
              ) : null}
            </form>
          </div>
        </div>
        </div>
      </div>
      </div>
    );
  }
}
